import { React, useAPI } from 'mcelroy-lib'
import { TablePage } from 'mcelroy-components'

/*
    Page to list and search localized resources (translations)
    Have to be type of translation administrator
*/
export function LocalizedResourcesPage() {
    // API localized resources list query
    const { loading, data } = useAPI(`
    query{
        localizedResources{
            id
            lang
            key
            value
        }
    }
    `)

    // Table columns
    const columns = [
        { title: 'Language', name: 'lang' },
        { title: 'Key', name: 'key' },
        { title: 'Value', name: 'value' }
    ]


    // Page display
    return (
        <TablePage columns={columns} data={data?.localizedResources} loading={loading}
            options={{
                keyColumn: 'id',
                limit: 100,
                rowClickTo: '/translations/:lang/:key'
            }}
            actions={[
                { label: 'New', to: '/create_translation' } , { label: 'Export/Import', to: '/batch_translation' }
            ]}
        />
    )
}
